import { WebRgWebsocketEvents } from "@/util/WebRgWebsocketManager";
import { useWebsocketManager } from "@/plugins/WebRgManagerPlugin";

export function useWebsocket(callbacks: WebRgWebsocketEvents) {
    const ws = useWebsocketManager();
    onMounted(() => {
        ws.addEventHandler(callbacks);
    });
    onUnmounted(() => {
        ws.removeEventHandler(callbacks);
    });
}
